import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am{" "}
            <span className="purple">Jeevittan Krishnan </span>
            from <span className="purple"> Ipoh, Malaysia.</span>
            <br />
            I'm a undergraduate student in Universiti Sains Malaysia, currently
            pursuing final year in Bachelor of Computer Sciences. I specialize
            in CyberSecurity but for some reasons i frequently get distracted in
            Web Development and creating friendly User Experience.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Valorant👻
            </li>
            <li className="about-activity">
              <ImPointRight /> Go For Hiking🏞️
            </li>
            <li className="about-activity">
              <ImPointRight /> Play Badminton🏸😍
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
